<template>
  <div v-if="rows.length > 0">
    <p v-if="rows.length == 1">
      {{ rows[0].name }}
    </p>
    <p v-else>
      <i
        class="las la-plus-square"
        @click="fnSelectRow"
        v-if="rowId != activeRow"
      ></i>
      <i
        class="lar la-minus-square"
        @click="fnCloseExpand"
        v-if="rowId == activeRow"
      ></i
      >{{ rows[0].name }}
    </p>

    <b-alert
      :show="true"
      variant="light"
      v-if="rows.length > 1 && rowId == activeRow"
      class="mb-0"
    >
      <div class="iq-alert-text">
        <p class="mb-0 fs-900" v-for="(row, index) in getSortRow" :key="index">
          {{ row.name }}
        </p>
      </div>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: 'WDExpandCell',
  props: ['rowId', 'rows', 'activeRow'],
  computed: {
    getSortRow() {
      return this.rows.sort((a, b) => {
        let fa = a.name.toLowerCase()
        let fb = b.name.toLowerCase()

        if (fa < fb) {
          return -1
        }
        if (fa > fb) {
          return 1
        }
        return 0
      })
    }
  },
  methods: {
    fnSelectRow() {
      this.$emit('fnSelectRow')
    },
    fnCloseExpand() {
      this.$emit('fnCloseExpand')
    }
  }
}
</script>
